// extracted by mini-css-extract-plugin
export var heading = "brand-socials-module--heading--ckWgo";
export var list = "brand-socials-module--list--iRkLe";